'use strict';

var processInclude = require('@sfra/util');

$(document).ready(function () {
    processInclude(require('./login/login'));
});
